import { IAgentCard, EAgentCardAccountType } from '../../types/agentCard';

export function isManagementCompany({ accountType }: IAgentCard) {
  return accountType === EAgentCardAccountType.ManagementCompany;
}
